import { ReactNode } from 'react';
import Tooltip from 'components/tooltip/Tooltip';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { Glyphicon } from 'react-bootstrap';
import { SectionHeaderContainer } from './SectionHeader.styles';

interface SectionHeaderProps {
  title: string | ReactNode;
  id: string;
  tooltip?: string | ReactNode;
  buttons?: ReactNode;
  subtitle?: string | ReactNode;
  isLoading?: boolean;
}

const SectionHeader = ({
  title,
  id,
  tooltip,
  buttons,
  subtitle,
  isLoading,
}: SectionHeaderProps) => {
  if (isLoading) {
    return (
      <>
        <LoadingPlaceholder linesCount={1.3} width="50%" />
        {subtitle && <LoadingPlaceholder linesCount={1} width="80%" />}
      </>
    );
  }

  return (
    <SectionHeaderContainer
      className="section-header-container"
      data-testid={`${id}-section-header`}
    >
      <div>
        <div className="title-container">
          <h3 data-testid={`${id}-title`}>{title}</h3>
          {tooltip && (
            <Tooltip id={`${id}-tooltip`} text={tooltip}>
              <Glyphicon glyph="info-sign" />
            </Tooltip>
          )}
        </div>
        {subtitle && <p className="section-header-subtitle">{subtitle}</p>}
      </div>
      {buttons && <div className="section-header-buttons">{buttons}</div>}
    </SectionHeaderContainer>
  );
};

SectionHeader.defaultProps = {
  tooltip: undefined,
  buttons: undefined,
  subtitle: undefined,
  isLoading: false,
};

export default SectionHeader;
